// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZJIM","question":"styles_question__18I0n","description":"styles_description__Olplv"};